module.exports = __webpack_public_path__ + "static/img/test2.e10147bf.jpg";